<template>
  <div
    class="top-right-action-buttons"
    :class="{ 'regenerate-btn-styles': showRegenerate }"
  >
    <cvt-button
      v-if="showDuplicate"
      class="ab-duplicate-btn"
      color="light"
      size="sm"
      :outlined="false"
      :icon="iconConfig.propertiesSidebar.copy || 'copy'"
      @click="$emit('duplicate')"
    />

    <cvt-button
      v-if="showRegenerate"
      class="ab-regenerate-btn"
      color="light"
      size="sm"
      :outlined="false"
      :icon="'refresh'"
      @click="
        () => {
          $emit('regenerate')
        }
      "
    />

    <cvt-button
      v-if="showDelete"
      class="ab-delete-btn"
      color="light"
      size="sm"
      :outlined="false"
      :icon="iconConfig.propertiesSidebar.remove || 'trash'"
      @click="$emit('remove')"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    showDuplicate: {
      type: Boolean,
      default: () => true,
    },
    showDelete: {
      type: Boolean,
      default: () => true,
    },
    showRegenerate: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    ...mapState('globalTheme', {
      iconConfig: ({ iconConfig }) => iconConfig,
    }),
  },
}
</script>

<style lang="scss" scoped>
.top-right-action-buttons {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 30px;
  background: #ffffff;
  bottom: -28px;
  left: calc(50% - 30px);
  right: calc(50% - 30px);
  z-index: 1000;

  border: 1px solid #e2e6ed;
  border-radius: 6px;
  box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.04),
    0px 2px 4px rgba(96, 97, 112, 0.16);

  .ab-duplicate-btn,
  .ab-delete-btn,
  .ab-regenerate-btn {
    height: 100%;
    width: 100%;
    min-width: 20px;
    padding: 4px;

    display: flex;
    align-content: center;
    align-items: center;

    i {
      font-size: 12px;
    }
  }

  .ab-duplicate-btn {
    border-radius: 6px 0px 0px 6px;
  }
  .ab-delete-btn {
    border-radius: 0px 6px 6px 0px;
  }
  .ab-regenerate-btn {
    border-radius: 0;
  }
}

.regenerate-btn-styles {
  width: 90px;
}
</style>
